import { Component, Input, forwardRef, ViewChild, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { ItmAbstractControl } from '../itm-abstract-control';
@Component({
	selector: 'itm-textbox',
	templateUrl: './itm-textbox.component.html',
	styleUrls: ['./itm-textbox.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ItmTextboxComponent),
			multi: true
		},
		{
			provide: NG_VALIDATORS,
			useExisting: forwardRef(() => ItmTextboxComponent),
			multi: true
		}
	]
})
export class ItmTextboxComponent extends ItmAbstractControl<any> {

	@ViewChild("controlRef") controlRef: ElementRef;

	@Input() placeholder: string = "";
	@Input() type: string = "text";
	@Input() inputGroupLabel: string;

	getControlRef(): ElementRef {
		return this.controlRef;
	}

	// myOnChange(v: string) {
	// 	this.val = v;
	// 	this.onChange(v);
	// }

	// myOnBlur() {
	// 	this.onTouched()
	// }

}
